import { render, staticRenderFns } from "./AlipayAuth.vue?vue&type=template&id=368e9330"
import script from "./AlipayAuth.vue?vue&type=script&lang=js"
export * from "./AlipayAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('368e9330')) {
      api.createRecord('368e9330', component.options)
    } else {
      api.reload('368e9330', component.options)
    }
    module.hot.accept("./AlipayAuth.vue?vue&type=template&id=368e9330", function () {
      api.rerender('368e9330', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mchApp/AlipayAuth.vue"
export default component.exports